
export default {
  name: 'SelectedFilterOption',
  props: {
    selectedFilter: {
      type: Object,
      required: true,
      default: () => {}, // {query: startTimeIdx, queryValue: "7", text: "오후 7시"}
    },
  },
  computed: {
    filterText() {
      return this.selectedFilter?.text;
    },
  },
  methods: {
    pushRouteQueryUrl() {
      this.selectedFilter?.removeState();
      // route query 지우기
      this.$router.push({
        query: this.selectedFilter.pushQuery,
      });
    },
  },
};
